// Honest ComingSoon for the anchored-create piece (plan §B, deferred
// F-COMMENTS-ANCHOR).
//
// "Comment on a Word selection" needs an Office.js reader (`Word.run` →
// `selection.text` + offset → `POST /threads` with `section_id`/`anchor_text`)
// plus the `anchor_lost` re-anchor flow — both W2 adapters that do not exist
// yet and need a real-Word smoke (one-way door §7). Rather than fake them with
// a disabled button that implies a working flow, this is an explicit, honest
// placeholder. Dispatches nothing.
//
// Thin LOCAL block (NOT the shell `<ComingSoon>`), mirroring
// `versions/SnapshotComingSoon.tsx`. CLAUDE.md §9: logical utilities only, all
// strings via `t('comments.anchor.*')`.

import { useTranslation } from 'react-i18next'

export function AnchorComingSoon(): JSX.Element {
  const { t } = useTranslation()
  return (
    <div
      data-testid="comments-anchor-coming-soon"
      className="border-t border-ink/10 px-3.5 py-4"
    >
      <div className="mb-2 text-[10px] font-bold uppercase tracking-wider text-ink/40">
        {t('comments.anchor.header')}
      </div>
      <div className="flex flex-col items-center justify-center gap-2 px-4 py-6 text-center">
        <div className="font-serif text-sm font-semibold text-ink">
          {t('comments.anchor.comingSoonTitle')}
        </div>
        <p className="max-w-[240px] text-xs leading-relaxed text-ink/60">
          {t('comments.anchor.comingSoonBody')}
        </p>
      </div>
    </div>
  )
}
